import { Link, createFileRoute } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";
import { QuizContent } from "~/components/quiz/quiz-content";

export const Route = createFileRoute("/app/learn/jlpt/$level/quiz/")({
	component: QuizPage,
});

function QuizPage() {
	const { level } = Route.useParams();

	return (
		<div className="max-w-screen-md mx-auto px-3 sm:px-4 py-4">
			<div className="mb-4">
				<Link
					to="/app/learn/jlpt/$level"
					params={{ level }}
					className="flex items-center gap-1 text-pink-500/80 hover:text-pink-600 transition-colors text-sm"
				>
					<ChevronLeft className="w-4 h-4" />
					<span>Back to list</span>
				</Link>
			</div>

			<section className="mb-4">
				<h1 className="text-xl sm:text-2xl font-semibold text-pink-600 mb-2">
					Quiz Time!
				</h1>
				<p className="text-xs sm:text-sm text-muted-foreground">
					Test your knowledge of JLPT {level.toUpperCase()} materials with this
					interactive quiz. Each question will test your understanding of
					vocabulary, grammar, and reading comprehension.
				</p>
			</section>

			<QuizContent level={level} />
		</div>
	);
}
